import {createMemoryStorage} from './memory';
import {createStorage} from './base';

const
    available = () => {
        if (typeof localStorage === 'undefined') {
            return false;
        }
        try {
            const key = 'test';
            let value = localStorage.getItem(key);

            localStorage.setItem(key, value);
            if (value === null) {
                localStorage.removeItem(key);
            }
            return true;
        } catch (error) {
            return false;
        }
    },
    createLocalStorage = (
        available() ?
            name => createStorage(name, localStorage) :
            createMemoryStorage);

export {
    createLocalStorage
};
